/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Rights_Objection_DescInputs */

const es_privacy_policy_rights_objection_desc = /** @type {(inputs: Privacy_Policy_Rights_Objection_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetar el procesamiento basado en intereses legitimos`)
};

const en_privacy_policy_rights_objection_desc = /** @type {(inputs: Privacy_Policy_Rights_Objection_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Object to processing based on legitimate interests`)
};

/**
* | output |
* | --- |
* | "Object to processing based on legitimate interests" |
*
* @param {Privacy_Policy_Rights_Objection_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_rights_objection_desc = /** @type {((inputs?: Privacy_Policy_Rights_Objection_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Rights_Objection_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_rights_objection_desc(inputs)
	return en_privacy_policy_rights_objection_desc(inputs)
});
export { privacy_policy_rights_objection_desc as "privacy_policy.rights.objection_desc" }